import ActorsHandler from './ActorsHandler';

export default ActorsHandler;


// WEBPACK FOOTER //
// /src/components/mailThread/compose/actorsHandler/index.js